import { render, staticRenderFns } from "./IngredientAisleListView.vue?vue&type=template&id=2859ceab&scoped=true"
import script from "./IngredientAisleListView.vue?vue&type=script&lang=js"
export * from "./IngredientAisleListView.vue?vue&type=script&lang=js"
import style0 from "./IngredientAisleListView.vue?vue&type=style&index=0&id=2859ceab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859ceab",
  null
  
)

export default component.exports